import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  transparent?: boolean;
}

export default function Navbar({ transparent = false }: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  const navClasses = transparent && !isScrolled
    ? 'bg-transparent'
    : 'bg-white shadow-sm';

  const textClasses = transparent && !isScrolled
    ? 'text-white'
    : 'text-gray-800';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navClasses}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/e5458c9a-2fee-456b-be7f-ac70621fd81d.png" 
              alt="Next Phase Logistics" 
              className="h-12 w-auto"
            />
          </Link>

          <div className="flex items-center gap-8">
            <Link 
              to="/services" 
              className={`text-sm font-medium transition-colors hover:text-[#E67E50] whitespace-nowrap ${textClasses} ${isActive('/services') ? 'text-[#E67E50]' : ''}`}
            >
              Services
            </Link>
            <Link 
              to="/return-policy" 
              className={`text-sm font-medium transition-colors hover:text-[#E67E50] whitespace-nowrap ${textClasses} ${isActive('/return-policy') ? 'text-[#E67E50]' : ''}`}
            >
              Returns
            </Link>
            <Link 
              to="/privacy-policy" 
              className={`text-sm font-medium transition-colors hover:text-[#E67E50] whitespace-nowrap ${textClasses} ${isActive('/privacy-policy') ? 'text-[#E67E50]' : ''}`}
            >
              Privacy
            </Link>
          </div>

          <div className="flex items-center gap-4">
            <a 
              href="tel:+13173972529" 
              className={`text-sm font-medium whitespace-nowrap ${textClasses}`}
            >
              +1 (317) 397-2529
            </a>
            <a 
              href="mailto:mark@aikinslogistics.com" 
              className="px-6 py-2 bg-[#F5A962] text-white text-sm font-medium rounded-full hover:bg-[#E67E50] transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
